'use client';

import type { CartSaved } from '@/types/manage.types';
import type { ICartRepository } from '../../domain/repositories/ICartRepository';

const KEY = 'app.cart.v1';

export class LocalStorageCartRepository implements ICartRepository {
  async getCart(): Promise<CartSaved[]> {
    if (typeof window === 'undefined') return [];
    try {
      const raw = window.localStorage.getItem(KEY);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return parsed as CartSaved[];
    } catch {
      return [];
    }
  }

  async saveCart(items: CartSaved[]): Promise<void> {
    if (typeof window === 'undefined') return;
    try {
      window.localStorage.setItem(KEY, JSON.stringify(items));
    } catch {
      // ignore storage errors
    }
  }

  async clearCart(): Promise<void> {
    if (typeof window === 'undefined') return;
    try {
      window.localStorage.removeItem(KEY);
    } catch {
      // ignore
    }
  }
}
